// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XCanq","rootNoMargin":"styles_rootNoMargin__22esi"};